import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login, user } = useAuth();
  const navigate = useNavigate();

  // Redirect if already logged in
  React.useEffect(() => {
    if (user) {
      navigate('/dashboard');
    }
  }, [user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await login(email, password);
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #fff7ed 0%, #ffedd5 50%, #fed7aa 100%)'
    }}>
      <div className="card" style={{ width: '100%', maxWidth: '400px', boxShadow: '0 4px 20px rgba(249, 115, 22, 0.15)' }}>
        <div className="text-center mb-5">
          <img src="/lp-logo.png" alt="LP Logo" style={{ height: '60px', marginBottom: '16px' }} />
          <h1 style={{ color: '#ea580c', marginBottom: '8px' }}>LP Learning & Assessment Portal</h1>
          <p className="text-muted">Admin & Examiner Login</p>
        </div>

        {error && <div className="alert alert-error">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              required
            />
          </div>

          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              required
            />
          </div>

          <button
            type="submit"
            className="btn btn-primary btn-lg"
            style={{ width: '100%' }}
            disabled={loading}
          >
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>

        <div className="text-center mt-4">
          <Link to="/exam" style={{ color: '#f97316', textDecoration: 'none' }}>
            Take an Exam with Access Code
          </Link>
        </div>
        <div className="text-center mt-2">
          <Link to="/verify" style={{ color: '#6b7280', textDecoration: 'none', fontSize: '14px' }}>
            Verify a certificate
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Login;
